// Remix Screen
// author rodolfo lopez pintor <rlp@nebular.tv>
//////////////////////////////////////////////////////////////

import m from "mithril";

import {
	defineWidget, CardieWidget, ButtonNew,
	NoticeWidget, Notification, InputWidget, ComboWidget
} from "@nebularstreams/libmui";
import {loadContent, startTimerForRefresh, reconfigVtransOpcode} from "../Api";

import {STATE_CHROMAKEY as STATE} from "../State";
import {ContentBrowser} from "./misc/ContentBrowser";

import {NanoPlayer, CustomNanoPlayer} from "./misc/NanoPlayer";
import {StreamCard} from "./misc/StreamCard";
import {TitleBarWidget} from "./misc/TitleBarWidget";
import {ContentItem} from "./remix/VideoBucketList";
import {hslToRgbString, rgbToHslString} from "./hsltools";

/** whether to enable live streams functionality */




//////////////////////////////////////////////////////////////

const STR = {
	CHANGE_STREAM: "change stream",
	CARD_LIVESTREAM: "Chroma Key Source",
	CARD_LIVESTREAM_SOURCE: "Change Filter Configuration",
	CARD_LIVESTREAM_SOURCE_TITLE: "Enter the filter target stream",
	CARD_LIVESTREAM_SOURCE_HELP: "Type one target streamname to tweak the output in realtime",
	CARD_LIVESTREAM_SOURCE_HELP_EXISTING: "Drag and Drop this livestream into your current reMix. Make sure it remains online through your session",
	CLIP_ADDED: "Clip Added to Playlist",
	YOUR_VIDEOS: "Your Backgrounds in nanoStream Storage",
	YOUR_VIDEOS_EMPTY: "No backgrounds in your nanoStream Storage\nTo configure Chroma-Key you first need to upload some backgrounds.\nTry drag-and-drop from your File explorer, or press the button below.",
	YOUR_VIDEOS_EMPTY_FILTER: "No backgrounds matching your search\nPlease refine the search term",
	TITLE: "chromakey - nanoStream Studio",
	REFILTER: "Changing filter parameters can take several seconds while the underlying processes are restarted. If the video gets stuck, please collapse and expand the video window by clicking on the caret icon at the top, in order to refresh the player."
};
//////////////////////////////////////////////////////////////

const {service: SERVICE} = STATE;

//////////////////////////////////////////////////////////////


function runStreamName(streamname) {
	// nothing to do
	STATE.streamname = streamname;
}

function validateHsl(color) {
	return color && color.split(":").length === 3;
}

function getHslHtml(color) {
	const [h, s, l] = color.split(":");
	if (!!h && !!s && !!l)
		return "hsl(" + h + ", " + (parseFloat(s) * 100) + "%, " + (parseFloat(l) * 100) + "%)";

}

function validateRgb(color) {
	return color && color.length === 6 && parseInt(color, 16) > 0;
}

//////////////////////////////////////////////////////////////
// UI WIDGETS

const

	// widget: the list of videos in the bucket
	VideoContent = defineWidget(
		({attrs}) => m(ContentBrowser, {
			state: STATE,
			noUpload: false,
			filter: true,
			collapsed: true,
			icon: "mountain",
			accept: "video/mp4",
			service: STATE.service,
			orga: attrs.orga,
			loadContent: true,
			prefix: `${STATE.service}/${attrs.orga}/`,
			title: STR.YOUR_VIDEOS,
			emptyMessage: STR.YOUR_VIDEOS_EMPTY,
			emptyFilter: STR.YOUR_VIDEOS_EMPTY_FILTER,
			uploadMessage: STR.UPLOAD_VIDEO,
			itemWidget: ContentItem
		})
	),

	// widget: Main Screen
	ChromaKeyScreen = defineWidget(
		({attrs, state}) => [
			m(TitleBarWidget, {
				title: "ChromaKey",
				rootTitle: "Studio",
				rootTitleClick: () => m.route.set(`/${attrs.orga}`)
			}),
			m(
				".flexcol.h-100.ohidden.grows.scrolly.outercontent",
				{
					class: STATE.mainBusy ? "mainbusy" : ""
				},
				m(".flexcol.grows.noshrink.innercontent", [

					m(CardieWidget,
						{
							class: "status",
							nofold: true,
							element: "div"
						},

						// first card
						STATE.streamname
							? [
								m(".streamname.fixstreamname", STATE.streamname),
								m(InputWidget, {
									label: "Target Chromakey Stream Name",
									value: STATE.targetStreams.streamname || "",
									hint: attrs.orga ? attrs.orga + "-xxxxx" : "Enter a streamname",
									maxlength: 11,
									class: state.isValid ? "valid" : "invalid",
									onchange: (streamname) => {
										STATE.targetStreams.streamname = streamname;
										m.route.set(`/${attrs.orga}/${SERVICE}/${STATE.streamname}/${STATE.targetStreams.streamname}`)
									}
								}),
								m(".flexrow.h-100", [
									m(ButtonNew, {
										class: "orangebutton h-100",
										icon: "sync",
										text: STR.CHANGE_STREAM,
										onClick: () => {
											delete STATE.streamname;
											STATE.content = {};
											delete STATE.currentItem;
											m.route.set(`/${attrs.orga}/${SERVICE}`)
										}
									}),
								])
							]
							: [
								m(StreamCard, {
									state: STATE, service: SERVICE, orga: attrs.orga, class: "grows"
								})
							]
					),

					// body
					...STATE.streamname
						? [
							// show error if there is such
							...STATE.errorchroma
								? [
									m(NoticeWidget, {
										class: "rednotice marg-2 grows",
										icon: "exclamation-triangle",
										text: STATE.error,
										onClick: () => {
											delete STATE.errorchroma;
											m.redraw();
										}
									})
								]
								: [],

							m(".flexrow.ohidden.maincontainer.grows.chromascreen", [

								// If there is stuff in the bucker, or if there is a setlist playling


								m(".flexcol.grows.ohidden.part-left", [

									m(NanoPlayer, {
										state: STATE,
										title: STR.CARD_LIVESTREAM
									}),

									// Always show bucket list
									m(VideoContent, {orga: attrs.orga, state: STATE}),
								]),


								// right column
								m(".flexcol.grows.ohidden.part-right.h-100", STATE.targetStreams.streamname ? [

									m(CustomNanoPlayer, {
										title: STR.CARD_LIVESTREAM_SOURCE,
										textTitle: STR.CARD_LIVESTREAM_SOURCE_TITLE,
										state: STATE.targetStreams,
										help: STR.CARD_LIVESTREAM_SOURCE_HELP,
										helpExisting: STR.CARD_LIVESTREAM_SOURCE_HELP_EXISTING,
										liveStreamItem: ContentItem,
										orga: attrs.orga,
										fixed: true,
										key: STATE.refreshKey
									}, [
										m(".flexrow.w-100.filterconfig", [
											m(ComboWidget, {
												value: STATE.opcode.filter || "chromakey",
												items: [
													{name: "HSL", value: "hsvkey"},
													{name: "RGB", value: "chromakey"}
												],
												onchange: (value) => {
													STATE.opcode.filter = value;
													if (STATE.opcode.color) {
														if (value === "hsvkey") {
															if (validateRgb(STATE.opcode.color)) {
																STATE.opcode.color = rgbToHslString(STATE.opcode.color);
															}
														} else {
															if (validateHsl(STATE.opcode.color)) {
																STATE.opcode.color = hslToRgbString(STATE.opcode.color);
															}
														}
													}
													m.redraw();
												}
											}),
											m(InputWidget, {
												itemClass: "grows",
												label: "color like " + (STATE.opcode.filter === "hsvkey" ? "hue:sat:lum" : "RRGGBB"),
												value: STATE.opcode.color,
												hint: "00FF00",
												maxlength: 16,
												class: state.isValid ? "valid" : "invalid",
												oninput: (value) => {
													state.isValid = STATE.opcode.filter === "hsvkey" ? validateHsl(value) : validateRgb(value);
													m.redraw();
												},
												onchange: (color) => {
													STATE.opcode.color = color;
													m.redraw();
												}
											}),
											m(".colorpreview.unitsize", {
												style: {
													backgroundColor: STATE.opcode.filter === "hsvkey"
														? getHslHtml(STATE.opcode.color)
														: "#" + STATE.opcode.color
												}
											}),
											m(InputWidget, {
												itemClass: "grows",
												label: "similarity",
												value: STATE.opcode.similarity,
												max: 1,
												min: 0,
												onchange: (similarity) => {
													const sim = parseFloat(similarity) || 0;
													if (sim > 0 && sim <= 1) {
														STATE.opcode.similarity = sim;
														m.redraw();
													}
												}
											}),
											m(InputWidget, {
												itemClass: "grows",
												label: "blending",
												value: STATE.opcode.blending,
												hint: "1",
												max: 1,
												min: 0,

												onchange: (blending) => {
													const sim = parseFloat(blending) || 0;
													if (sim > 0 && sim <= 1) {
														STATE.opcode.blending = sim;
														m.redraw();
													}
												}
											}),
											m(ButtonNew, {
												itemClass: "grows",
												class: "changebutton",
												icon: "sync",
												text: "change filter",
												onClick: () => reconfig()
											})
										]),
										m(NoticeWidget, {
											class: "aviso marg-2 marg-h grows",
											icon: "info",
											text: STR.REFILTER,
											onClick: () => {
												delete STATE.errorchroma;
												m.redraw();
											}
										})									])
								] : [])
							])
						] : []
				])
			)
		],
		({attrs}) => {
			if (attrs.secondary) {
				STATE.targetStreams.streamname = attrs.secondary;
			}
			if (attrs.key) {
				runStreamName(attrs.key);
			} else if (STATE.streamname) {
				m.route.set(`/${attrs.orga}/${SERVICE}/${STATE.streamname}`);
			}
			document.title = STR.TITLE
		},
		undefined,
		() => startTimerForRefresh(false)
	);

function reconfig() {
	reconfigVtransOpcode(STATE.streamname, "chromakey", STATE.opcode)
		.then(() => {
			setTimeout(() => {
				STATE.refreshKey = Date.now();
				m.redraw();
			}, 7500);
		})
		.catch((e) => {
			STATE.errochroma = e;
			m.redraw();
		})
}

export default ChromaKeyScreen;
